import { jsx as _jsx } from "react/jsx-runtime";
export default function Divider() {
    const styles = {
        divider: {
            width: "100%",
            borderTop: "1px solid lightgrey",
            margin: "16px 0"
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        style: styles.divider
    });
}
